// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.conversation.note.SatelliteWebLandlordNoteHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordNoteHandler_createOrUpdate,
  SatelliteWebLandlordNoteHandler_delete,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebLandlordNoteCreateOrUpdateRequestDto,
  SatelliteWebLandlordNoteDeleteRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebLandlordNoteHandler_createOrUpdate_Args {
  postData: SatelliteWebLandlordNoteCreateOrUpdateRequestDto;
}

export type SatelliteWebLandlordNoteHandler_createOrUpdate_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordNoteHandler_createOrUpdate_Args
>;

/**
 * Create or update a conversation's note
 */
export const useSatelliteWebLandlordNoteHandler_createOrUpdate = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordNoteHandler_createOrUpdate_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordNoteHandler_createOrUpdate_Args) =>
      SatelliteWebLandlordNoteHandler_createOrUpdate(args.postData, httpClient),
  });
};

export interface SatelliteWebLandlordNoteHandler_delete_Args {
  postData: SatelliteWebLandlordNoteDeleteRequestDto;
}

export type SatelliteWebLandlordNoteHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebLandlordNoteHandler_delete_Args
>;

/**
 * Delete a conversation's note
 */
export const useSatelliteWebLandlordNoteHandler_delete = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordNoteHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebLandlordNoteHandler_delete_Args) =>
      SatelliteWebLandlordNoteHandler_delete(args.postData, httpClient),
  });
};
